var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSlideNext = function SvgSlideNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4322",
    transform: "translate(-1340 -826)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none",
    "data-name": "Rectangle 2356",
    rx: 24,
    transform: "translate(1340 826)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22cb5b",
    stroke: "#22cb5b",
    strokeWidth: 0.4,
    d: "M1360.226 857.773a.777.777 0 0 1-.076-1.008l.075-.087 6.642-6.678-6.642-6.678a.777.777 0 0 1-.075-1.008l.075-.087a.767.767 0 0 1 1-.075l.086.075 7.191 7.223a.777.777 0 0 1 .075 1.008l-.075.087-7.187 7.228a.767.767 0 0 1-1.089 0Z",
    "data-name": "Path 369"
  }))));
};
export default SvgSlideNext;